import ChatModal from "../../../Components/ChatModal/ChatModal";

const ExitModal = ({ showExitModal, setShowExitModal, handleLeave }) => {
  if (!showExitModal) return null;
  
  return (
    <ChatModal
      onClose={() => setShowExitModal(false)}
      width={"300px"}
      height={"auto"}
      padding={"0px"}
      isOpen={showExitModal}
      children={
        <div>
          <div className="logout-modal-container">
            <div className="logout-modal-header text-center">Exit Aris Dialogues</div>
            <div className="logout-modal-body text-center">Are you sure you want to leave Aris Dialogues?</div>
          </div>
          <div className="logout-modal-button-container">
            <div
              className="logout-cancel"
              onClick={() => setShowExitModal(false)}
            >
              Cancel
            </div>
            <div
              className="logout-cancel logout-btn"
              onClick={handleLeave}
            >
              Leave
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ExitModal;